<style lang="less" scoped>
@import "video.less";
</style>
<template>
  <div class="video_box">
    <div id="top_video"></div>
    <div class="describe">
      <div class="title">{{contentObj.title}}</div>
      <div class="intro" v-show="contentObj.description">
        {{contentObj.description}}
      </div>
    </div>
    <div class="recommend" v-if="recomms.length > 0">
      <div class="title2">热播推荐</div>
      <div class="bottom">
        <div class="item" v-for="item in recomms" :key="item.id" @click="changeVid(item.id)">
          <img :src="item.thumbnailUrl" alt />
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
    <!-- <back-index></back-index> -->
  </div>
</template>
<script>
// import BackIndex from '../../components/backtoindex'
// import Txplayer from "../../../static/txplayer";
// import tvp from 'txPlayer'
let TxPlayer = window.Txplayer
let player
export default {
  data () {
    return {
      contentObj: {},
      txId: '',
      recomms: []
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    // let self = this
    // self.$nextTick(function () {
    //   player.play(self.txId)
    // })
  },
  methods: {
    getList: function () {
      let self = this
      let id = this.$route.query.id
      console.log(this.$route.query.id)
      self.$http.get('https://goapi.gmic.cn/api/v1/room/playbacks/' + id).then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          self.contentObj = res.data.data
          self.txId = res.data.data.playBack.tencent_vid
          player = new TxPlayer({
            containerId: 'top_video',
            vid: self.txId,
            width: '100%',
            height: screen.availHeight / 3
          })
          // console.log(self.txId)
          player.on('ready', () => {
            player.play(self.txId)
          }) // 初始化完成
          self.getRecoms(6)
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    getRandomArrayElements: function (arr, count) {
      let shuffled = arr.slice(0)
      let i = arr.length
      let min = i - count
      if (min <= 0) {
        min = i - 1
      }
      let temp, index
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random())
        temp = shuffled[index]
        shuffled[index] = shuffled[i]
        shuffled[i] = temp
      }
      return shuffled.slice(min)
    },
    getRecoms: function (currId) {
      let self = this
      self.$http.get('https://goapi.gmic.cn/api/v1/room/rand_playbacks/3', true).then((res) => {
        // console.log(11111)
        // console.log(res)
        let arr = res.data.data
        // arr = arr.filter(item => item.id !== currId)
        // let out = this.getRandomArrayElements(arr, 3)
        self.recomms = arr
      }).catch((err) => {
        console.log(err)
        console.log('推荐失败')
      }).finally(() => {
      })
    },
    changeVid: function (id) {
      let self = this
      let changeObjtct = self.recomms.filter(item => item.id === id)[0]
      // console.log(changeObjtct)
      self.contentObj = changeObjtct
      // console.log(changeObjtct)
      // self.txId = changeObjtct.playBack.tencent_vid
      player.play(changeObjtct.playBack.tencent_vid)
      self.getRecoms(id)
    }
  },
  destroyed () {
    player.pause()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/video/video.vue